module.exports = __webpack_public_path__ + "img/p2-58.f6320d11.png";